import { render, staticRenderFns } from "./ViewAcademyReviews.vue?vue&type=template&id=abd3457e&scoped=true"
import script from "./ViewAcademyReviews.vue?vue&type=script&lang=js"
export * from "./ViewAcademyReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd3457e",
  null
  
)

export default component.exports